// ** Redux Imports
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// ** Axios Imports
import API from "../../../../utility/custom/API";
import { toast } from "react-toastify";

import axios from "axios";

export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
  const response = ''
  return response.data
})


export const getData = createAsyncThunk('appOrders/getData', async params => {
  let response = ''
 if (params.filters !== null && params.filters.state.length > 0) {
   response = await API.get(`orders?status=${params.filters.status.value}&
    state=${params.filters.state}&
    is_paid=${params.filters.is_paid === true ? "1" : "0"}&
    cash_on_delivery=${params.filters.cash_on_delivery === true ? "1" : "0"}
    `)
   
 }
  if (params.filters !== null) {
    response = await API.get(`orders?status=${params.filters.status.value}&
    is_paid=${params.filters.is_paid === true ? "1" : "0"}&
    cash_on_delivery=${params.filters.cash_on_delivery === true ? "1" : "0"}
    `)
  } else {
    response = await API.get(`orders`)
  }
  return {
    data: response.data,
    allData: response.data,
    totalPages: response.total,
    params
    
  }
})


export const deleteOrders = createAsyncThunk('appOrders/deleteOrders', async (id, { dispatch, getState }) => {
  const dataInfo = new FormData()
  dataInfo.append("id", id)
  dataInfo.append("_method", 'delete')
  await API.post(`/items`, dataInfo)
  toast.success("با موفقیت عملیات انجام شد")
  await dispatch(getData(getState().orders.params))
  return id
})

export const appOrdersSlice = createSlice({
  name: 'appOrders',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    artists: [],
    countryIds: [],
    questions: [],
    categories: [],
    voicesAndSubtitles:[],
    answers:[],
    
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
  }
})

export default appOrdersSlice.reducer
